import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import CentersPage from './pages/CentersPage';
import LoginPage from './pages/LoginPage';
import GuestLoginPage from './pages/GuestLoginPage';
import RetreatLandingPage from './pages/RetreatLandingPage';
import RetreatDetailPage from './pages/RetreatDetailPage';
import RetreatsPage from './pages/RetreatsPage';
import StudentsPage from './pages/StudentsPage';
import SessionSelectionPage from './pages/SessionSelectionPage';
import AssignSessionsPage from './pages/AssignSessionsPage';
import ReviewPage from './pages/ReviewPage';
import SubmitPage from './pages/SubmitPage';
import ConfirmationPage from './pages/ConfirmationPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/retreat" replace />} />
      <Route path="/retreat" element={<RetreatLandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/guest-login" element={<GuestLoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/centers" element={<CentersPage />} />
        <Route path="/retreats" element={<RetreatsPage />} />
        <Route path="/retreat/:retreatId" element={<RetreatDetailPage />} />
        <Route path="/students" element={<StudentsPage />} />
        <Route path="/sessions" element={<SessionSelectionPage />} />
        <Route path="/assign-sessions" element={<AssignSessionsPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/submit" element={<SubmitPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/retreat" replace />} />
    </Routes>
  );
}

export default App;
